<th-app-notification></th-app-notification>

<div *ngIf="loading" class="d-flex justify-content-center">
  <i class="fas fa-spinner fa-spin fa-3x"></i>
</div>

<div id="sign-in-widget" [hidden]="loading"></div>
